import brandConfig from '~branding/discover/config.js'
import ImprintPage from '~brand-pages/discover/imprint'
import TermsOfUsePage from '~brand-pages/discover/terms-of-use'
import FAQPage from '~brand-pages/discover/faq'
import VoucherSaleAmountPage from '~brand-pages/discover/voucher-sale-amount'
import VoucherSaleCheckoutPage from '~brand-pages/discover/voucher-sale-checkout'
import VoucherSaleConfirmationPage from '~brand-pages/discover/voucher-sale-confirmation'
import VoucherSaleLandingPage from '~brand-pages/discover/voucher-sale'
import routerBuilder from './routerBuilder'

const router = routerBuilder('discover', {
  brandConfig,
  ImprintPage,
  TermsOfUsePage,
  TermsOfUsePageCompensation: null,
  VoucherSaleAmountPage,
  VoucherSaleCheckoutPage,
  VoucherSaleConfirmationPage,
  FAQPage,
  VoucherSaleLandingPage,
}, ['en', 'de'])

export default router
